const FOCUSABLE_SELECTOR =
  'button:not([disabled]), a[href], input:not([disabled]), select:not([disabled]), textarea:not([disabled]), [tabindex]:not([tabindex="-1"])';

export const getFocusableElements = (container) =>
  container ? Array.from(container.querySelectorAll(FOCUSABLE_SELECTOR)) : [];

export const focusFirstIn = (container) => {
  const [first] = getFocusableElements(container);
  if (first) {
    // The step scrolls itself into view, so focusing must not make the page jump.
    first.focus({ preventScroll: true });
  }
};
